var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { profileDetailsCacheKey } from "../api/cacheKeys.js";
import mutationFnFactory from "./mutation.js";
function useProfileMutation({
  config,
  keyProps,
  mutationOptions = {}
}) {
  const queryClient = useQueryClient();
  return useMutation(__spreadValues({
    mutationKey: profileDetailsCacheKey(keyProps),
    mutationFn: mutationFnFactory(config, keyProps),
    onSuccess: () => {
      return queryClient.invalidateQueries(profileDetailsCacheKey(keyProps));
    }
  }, mutationOptions));
}
function useMultiProfileMutation({
  config,
  mutationOptions = {}
}) {
  const queryClient = useQueryClient();
  return useMutation(__spreadValues({
    mutationFn: (payload) => {
      const { account } = payload;
      const keyProps = {
        accountId: account["cipher.accountId"],
        accountIdType: account.accountIdType
      };
      return new Promise((resolve, reject) => {
        const mutationFn = mutationFnFactory(config, keyProps);
        mutationFn(payload).then((response) => __async(this, null, function* () {
          yield queryClient.invalidateQueries(
            profileDetailsCacheKey(keyProps)
          );
          resolve(response);
        })).catch(reject);
      });
    }
  }, mutationOptions));
}
export { useMultiProfileMutation, useProfileMutation };
//# sourceMappingURL=profileMutation.js.map
